import { IUploadExcelTuyenDuongChiTietRequest } from '../../models/request/bus/uploadExcelRequest';
import { bus_tuyenduong_chitiet } from '../../models/response/bus/bus_tuyenduong_chitiet';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_TUYENDUONG_CHITIET_PATH = "bus/tuyen-duong-chi-tiet";

export interface IBusTuyenDuongChiTietSelectRequest {
	dm_coso_id: number;
	nam_hoc: string;
	bus_tuyenduong_id: number;
}

class BusTuyenDuongChiTietApi extends BaseCRUDApi<bus_tuyenduong_chitiet> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectAsync(request: IBusTuyenDuongChiTietSelectRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_CHITIET_PATH}/select`, {
			dm_coso_id: request.dm_coso_id,
			nam_hoc: request.nam_hoc,
			bus_tuyenduong_id: request.bus_tuyenduong_id,
		});
	}
	Import(request: IUploadExcelTuyenDuongChiTietRequest) {
		return apiClient.put(`bus/tuyen-duong-chi-tiet/import`, request);
	}
	ValidateImport(request: IUploadExcelTuyenDuongChiTietRequest) {
		return apiClient.put(`bus/tuyen-duong-chi-tiet/validate-import`, request);
	}
}
export const busTuyenDuongChiTietApi = new BusTuyenDuongChiTietApi(API_BUS_TUYENDUONG_CHITIET_PATH);
